<template>
  <div>
    <p v-if="title" class="progress-title">{{ title }}</p>

    <div class="native-progress-wrapper">
      <!-- blue while working, green when done -->
      <div
        class="native-progress-bar"
        :class="{ 'is-complete': isComplete }"
        :style="{ width: progressPercent + '%' }"
      ></div>

      <span class="progress-label">
        {{ $t('COMMON.PROGRESS') }}:
        <strong class="ml-2">{{ current_value }} / {{ max_value }}</strong>
      </span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';

export default {
  name: 'MemlistProgressBar',
  mixins: [toasts],
  props: ['max_value', 'current_value', 'title'],
  computed: {
    ...mapGetters(['currentCompanyId', 'currentPeriodId', 'periods', 'companies']),

    progressPercent() {
      if (!this.max_value || this.max_value === 0) return 0;
      return Math.min(100, (this.current_value / this.max_value) * 100);
    },

    // ‼️ new helper: true once we hit / exceed 100 %
    isComplete() {
      return this.progressPercent >= 100;
    }
  }
};
</script>

<style scoped>
.progress-title {
  font-weight: 600;
  font-size: 0.875rem;
  margin: 0;
  color: #34495e;
}

.native-progress-wrapper {
  position: relative;
  height: 2rem;
  width: 100%;
  background-color: #e9ecef;
  border-radius: 4px;
  overflow: hidden;
}

/* default (blue, animated) */
.native-progress-bar {
  position: relative;
  z-index: 1;
  height: 100%;
  background-color: #3699ff;
  transition: width 0.4s ease-in-out;
  background-image: repeating-linear-gradient(
    45deg,
    rgba(255, 255, 255, 0.3) 0 10px,
    rgba(255, 255, 255, 0.15) 10px 20px
  );
  background-size: 40px 40px;
  animation: progress-bar-stripes 1s linear infinite;
}

/* ✅ completed state — solid green, no stripes/animation */
.native-progress-bar.is-complete {
  background-color: #28a745;      /* Bootstrap’s “success” green */
  background-image: none;
  animation: none;
}

/* label */
.progress-label {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.9rem;
  font-weight: 500;
  color: #34495e;
  pointer-events: none;
  z-index: 2;
}

/* stripes animation */
@keyframes progress-bar-stripes {
  from { background-position: 40px 0; }
  to   { background-position: 0 0; }
}
</style>
